import React from 'react';
import {
  IconSwitch,
  IconBackup,
  IconLocation2,
  IconDisk,
  IconChip,
  IconMemory,
  IconConsole,
  IconMigration,
} from 'gatorcomponents';
import * as Styles from './PlanFeatures.styles';

const FEATURES = {
  infrastructure: [
    {
      key: 'unlimitedTransfer',
      icon: IconSwitch && <IconSwitch color="lowDark" size="sm" />,
    },
    {
      key: 'cloudServers',
      icon: IconBackup && <IconBackup color="lowDark" size="sm2" />,
    },
    {
      key: 'dedicatedIp',
      icon: IconLocation2 && <IconLocation2 color="lowDark" size="sm2" />,
    },
  ],
  performance: [
    {
      key: 'nvmeStorage',
      icon: IconDisk && <IconDisk color="lowDark" size="sm2" />,
    },
    {
      key: 'amdEpyc',
      icon: IconChip && <IconChip color="lowDark" size="sm2" />,
    },
    {
      key: 'ddr5Memory',
      icon: IconMemory && <IconMemory color="lowDark" size="sm2" />,
    },
  ],
  control: [
    {
      key: 'rootAccess',
      icon: IconConsole && <IconConsole color="lowDark" size="sm2" />,
    },
    {
      key: 'freeMigration',
      icon: IconMigration && <IconMigration color="lowDark" size="sm2" />,
    },
  ],
};

const FeatureTopic = ({
  icon, title, description, testId,
}) => (
  <Styles.Topic data-testid={testId}>
    <Styles.TopicIcon>{icon}</Styles.TopicIcon>
    <Styles.TopicContent>
      <Styles.TopicTitle>{title}</Styles.TopicTitle>
      <Styles.TopicDescription>{description}</Styles.TopicDescription>
    </Styles.TopicContent>
  </Styles.Topic>
);

const FeatureGroup = ({
  groupKey, label, items, locale,
}) => (
  <Styles.Group data-testid={`vpsoci-upgrade-features-group-${groupKey}`}>
    <Styles.GroupLabel>{label}</Styles.GroupLabel>
    <Styles.TopicsRow>
      {items.map(({ key, icon }) => (
        <FeatureTopic
          key={key}
          icon={icon}
          title={locale[key]?.title}
          description={locale[key]?.description}
          testId={`vpsoci-upgrade-features-topic-${key}`}
        />
      ))}
    </Styles.TopicsRow>
  </Styles.Group>
);

const PlanFeatures = ({ locale }) => {
  if (!locale) return null;

  return (
    <Styles.Container data-testid="vpsoci-upgrade-features">
      <Styles.SectionTitle>{locale.title}</Styles.SectionTitle>

      {Object.entries(FEATURES).map(([groupKey, items]) => (
        <FeatureGroup
          key={groupKey}
          groupKey={groupKey}
          label={locale.groups?.[groupKey]}
          items={items}
          locale={locale.items || {}}
        />
      ))}
    </Styles.Container>
  );
};

export default PlanFeatures;
